(() => {
  const section = document.querySelector('[data-maker-collection]');
  if (!section || section.dataset.initialized) return;
  section.dataset.initialized = 'true';
  const grid = section.querySelector('[data-maker-grid]');
  const sentinel = section.querySelector('[data-maker-next]');
  const status = sentinel.querySelector('.dm-load-status');
  const fallback = sentinel.querySelector('.dm-next-link');
  let next = sentinel.dataset.makerNext;
  let loading = false;
  let observer;
  const seen = new Set([...grid.children].map(card => card.dataset.productHandle));
  if (!next || !('IntersectionObserver' in window)) return;
  if (fallback) fallback.hidden = true;

  async function loadNext() {
    if (loading || !next) return;
    loading = true;
    status.textContent = 'Loading more pieces…';
    if (fallback) fallback.hidden = true;
    observer.unobserve(sentinel);
    try {
      const url = new URL(next, location.origin);
      const current = new URL(location.href);
      for (const key of ['preview_theme_id', 'pb']) {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      }
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const newGrid = doc.querySelector('[data-maker-grid]');
      const newSentinel = doc.querySelector('[data-maker-next]');
      if (!newGrid || !newSentinel) throw new Error('Collection markup missing');
      for (const card of [...newGrid.children]) {
        if (!seen.has(card.dataset.productHandle)) {
          seen.add(card.dataset.productHandle);
          grid.append(card);
        }
      }
      next = newSentinel.dataset.makerNext;
      sentinel.dataset.makerNext = next;
      status.textContent = next ? '' : 'You’ve seen the whole collection.';
      if (fallback && next) fallback.href = new URL(next, location.origin).href + '#collection-products';
      if (!next) observer.disconnect();
    } catch (_) {
      status.textContent = 'Couldn’t load more pieces. Try again.';
      if (fallback) fallback.hidden = false;
      // Leave a usable retry link instead of repeatedly retrying on an outage.
      loading = false;
      return;
    }
    loading = false;
    if (next) requestAnimationFrame(() => observer.observe(sentinel));
  }

  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) loadNext();
  }, { rootMargin: '600px 0px' });
  observer.observe(sentinel);
  if (fallback) fallback.addEventListener('click', event => {
    event.preventDefault();
    loadNext();
  });
})();
